import config from "../config";

let _nonOkWarned = false;

/**
 * POST /_/heartbeat to refresh the edge cookie.
 * Fail-open: catches all errors, never throws.
 */
export async function sendHeartbeat() {
  try {
    const res = await fetch(config.sessionEdge.heartbeatPath, {
      method: "POST",
      credentials: "include",
    });
    // fetch() does not reject on 4xx/5xx — surface non-OK once so a missing
    // CloudFront Function attach (S3 returning 405) doesn't fail silently.
    if (!res.ok && !_nonOkWarned) {
      _nonOkWarned = true;
      console.warn(
        "[sessionEdge] heartbeat returned " +
          res.status +
          " — vc-session-edge function may not be attached to this distribution"
      );
    }
  } catch (err) {
    console.warn("[sessionEdge] heartbeat failed:", err);
  }
}

/**
 * Expire the vc_last_activity cookie.
 */
export function clearSessionCookie() {
  const parts = [
    config.sessionEdge.cookieName + "=",
    "Path=/",
    "Max-Age=0",
    "SameSite=Lax",
  ];

  const domain = config.sessionEdge.cookieDomain;
  if (domain && domain !== "localhost") {
    parts.push("Domain=" + domain);
  }

  if (window.location.protocol === "https:") {
    parts.push("Secure");
  }

  document.cookie = parts.join("; ");
}

/**
 * Check if edge session management is enabled.
 */
export function isEdgeSessionEnabled() {
  return Boolean(config.sessionEdge.enabled);
}
